.supplier-button{background:#fff;border:1px solid;border-radius:25px;padding:0 16px;height:28px}.supplier-button:hover{background:#f1eefa}i{color:#43494e}.fa-trash-alt:hover{color:#e73d3d}.tcp-dump-icon{margin-top:12px;width:12px;height:12px}
/*# sourceMappingURL=session-actions.component-WSLJGYML.css.map */
